<template>
	<div>
		<div class="text-center">
			<a @click="openModal">
				<img :src="'@/../static/img/'+img"
				class="img-thumbnail img-manual-thumb"
				:alt="alt" v-if="dev">

				<img :src="'vue/img/'+img"
				class="img-thumbnail img-manual-thumb"
				:alt="alt" v-else>
			</a>
			<br>
			<span>{{alt}}</span>
		</div>

		<div :id="'thumbmodal-'+id" class="modal" @click="closeModal">

			<!-- The Close Button -->
			<span class="close" @click="closeModal">&times;</span>
			<br>
			<!-- Modal Content (The Image) -->
			<img class="modal-content" :src="'@/../static/img/'+img" v-if="dev">
			<img class="modal-content" :src="'vue/img/'+img" v-else>


			<!-- Modal Caption (Image Text) -->
			<div id="caption">{{alt}}</div>
		</div>
	</div>
</template>

<script>
const dev = process.env.NODE_ENV !== 'production'
export default {
	name: "ThumbImg",
	data() {
		return {
			'dev': dev
		};
	},
	methods : {
		openModal() {
			$('#thumbmodal-'+this.id).css('display', 'block');
		},

		closeModal() {
			$('#thumbmodal-'+this.id).css('display', 'none');
		}
	},
	props: ["img", "alt", "height", "width", "id"]
};
</script>

<style scoped>
.modal {
	display: none; /* Hidden by default */
	position: fixed; /* Stay in place */
	z-index: 1; /* Sit on top */
	padding-top: 100px; /* Location of the box */
	left: 0;
	top: 0;
	width: 100%; /* Full width */
	height: 100%; /* Full height */
	overflow: auto; /* Enable scroll if needed */
	background-color: rgb(0, 0, 0); /* Fallback color */
	background-color: rgba(0, 0, 0, 0.9); /* Black w/ opacity */
}

/* Modal Content (Image) */
.modal-content {
	margin: auto;
	display: block;
	/* 	width: 80%; */
	max-width: 1500px; 
}

/* Caption of Modal Image (Image Text) - Same Width as the Image */
#caption {
	margin: auto;
	display: block;
	width: 80%;
	max-width: 700px;
	text-align: center;
	color: #ccc;
	padding: 10px 0;
	height: 150px;
}

/* Add Animation - Zoom in the Modal */
.modal-content, #caption {
	animation-name: zoom;
	animation-duration: 0.6s;
}

@keyframes zoom {
	from {transform: scale(0)}
	to {transform: scale(1)}
}

/* The Close Button */
.close {
	position: absolute;
	top: 15px;
	right: 35px;
	color: #f1f1f1;
	font-size: 40px;
	font-weight: bold;
	transition: 0.3s;
}

.close:hover, .close:focus {
	color: #bbb;
	text-decoration: none;
	cursor: pointer;
}

.img-manual-thumb {
	max-height: 450px;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
	.modal-content {
		width: 100%;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/input/ThumbImg.vue